* {
  box-sizing: border-box;
}

:host {
  display: block;
  max-width: 100%;
  height: auto;
  color: var(--body-text-arrows-400);
  --font-family: var(--font-family-secondary);
}

::slotted(*) {
  font-size: inherit;
  font-weight: inherit;
  margin: 0;
}
::slotted(a) {
  color: var(--blue-layout-400-primary);
}
::slotted(a.primary) {
  color: var(--blue-layout-400-primary);
}
::slotted(a.secondary) {
  color: var(--body-text-arrows-400);
}

::slotted(b),
::slotted(.bold),
::slotted(strong) {
  font-weight: 700;
}

p {
  color: inherit;
  display: inline;
  margin: 0;
}

$smallFontSize: 9, 10, 11, 12, 13;
$fontSize: 14, 16, 18, 20, 24, 28, 32, 36, 48;
$lineHeight: 0.8, 1.2, 1.5, 2;
$fontWeight: 300, 400, 500, 600, 700;

@each $size in $smallFontSize {
  :host([fontSize='#{$size}']) {
    font-size: calc(#{$size}px + var(--dynamic-small-font-size-changer));
  }
}

@each $size in $fontSize {
  :host([fontSize='#{$size}']) {
    font-size: calc(#{$size}px + var(--dynamic-font-size-changer));
  }
}

@each $height in $lineHeight {
  :host([lineHeight='#{$height}']) {
    line-height: #{$height};
  }
}

@each $weight in $fontWeight {
  :host([fontWeight='#{$weight}']) {
    font-weight: #{$weight};
  }
}
